export default "__VITE_ASSET__f3uY9La7__"